import { getApiBaseUrl } from '../utils/apiConfig';

/**
 * 聊天函数 (Streaming)
 * @param {string} token 用户的 JWT Token
 * @param {string} content 聊天内容
 * @param {string} role 角色（例如 "塔罗牌占卜师"）
 * @returns {Promise<ReadableStreamDefaultReader<Uint8Array>>} 返回流读取器
 */
export const chat = async (
  token: string,
  content: string,
  role: string = "塔罗牌占卜师"
): Promise<ReadableStreamDefaultReader<Uint8Array>> => {
  const apiBaseUrl = getApiBaseUrl();

  // Call backend chat interface using fetch for streaming
  const response = await fetch(`${apiBaseUrl}/llm-chat-zhipu-stream-queue`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${token}`,
    },
    body: JSON.stringify({
      content,
      role,
    }),
  });

  if (!response.ok) {
    const txt = await response.text();
    throw new Error(`Chat failed: ${response.status} ${txt}`);
  }

  if (!response.body) {
    throw new Error('Chat failed: No response body');
  }

  return response.body.getReader();
};

